// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import router from './router'



//配置配置图标库
import 'font-awesome/css/font-awesome.min.css'
// 导入 ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 全局引入图表库
import * as echarts from 'echarts'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN' // Element 中文包
import elementEnLocale from 'element-ui/lib/locale/lang/en'    // Element 英文包
// 使用 ElementUI
//Vue.use(ElementUI);

Vue.use(VueI18n);

const messages = {
  'zh-CN': {
    login: '登录',
    logout:'退出登录',
    dashboard: '首页',
    orderQuery: '订单查询',
    query: '查询',
    submit:"提交",
    reset: '重置',
    startDate:"开始时间",
    endDate:"结束时间",
    currency:"币种",
    choose:"选择",
    cancel:"取 消",
    sure:"确 定",
    succeed:"成功",
    export_success:"导出成功",
    export_fail:"导出失败",
    selectAll:"全选",
    Excel:"请选择Excel",
    statusUnknown:"未知类型 :",
    alert_select:"您没有选择记录,请选择",
    please_input:"请输入",
    selected:"已选中",
    record:"记录",
    requestFailed:"请求失败，请稍后重试",
    unknownStatus:"未知状态",
    multipleValues:"请输入多个值,请使用英文逗号隔开，做到输入1000个值。例如：VALUE1,VALUE2,VALUE3",
    setValuesSuccess: "已设置 {count} 个值",
    addError:"新增失败",
    updaSucceed:"修改成功",
    updaError:"修改失败",
    please_inputOrder:"请输入流水订单号",
    DownloadInfo:"正在生成下载文件，请稍候...",
    export_truncated_warning: '数据量过大，仅导出前 {exported} 条（共 {original} 条）',
    date:"时间范围",
    selectDateRange:"请选择查询日期范围",
    day:"天",
    // 登录页面
    loginPage: {
      title: '登 录',
      desc: '欢迎登录商户后台管理系统',
      merNo:"输入商户号",
      accountPlaceholder: '请输入帐号',
      passwordPlaceholder: '请输入密码',
      captchaPlaceholder: '请输入验证码',
      submitBtn: '登录',
      accountRequired: '请输入帐号',
      passwordRequired: '请输入密码',
      serverError: '服务器连接失败，请稍后重试......'
    },
    // 主页
    home: {
      successAmount: '周成功金额',
      allCnt: '周总订单',
      allSuccCnt: '周成功订单',
      allSuccRate:"周成功率",
      WeeklyData:"近一周交易数据",
      Date:"日期",
      succAmount:"成功金额 (¥)",
      succCnt:"成功笔数",
      failAmount:"失败金额 (¥)",
      failCnt:"失败笔数",
      proportion:"成功/失败占比",
      succOrder:"成功订单",
      failOrder:"失败订单",
      seriesName:"订单状态",
      count:"笔",
      allUniqueEmails:"总笔数邮箱去重",
      succUniqueEmails:"成功笔数邮箱去重",
      emailSuccessRate:"邮箱去重成功率",
      allUniqueCard:"总笔数卡号去重",
      succUniqueCard:"成功笔数卡号去重",
      cardSuccessRate:"卡号去重成功率",
      successAmountTrend:"成功金额趋势",
      amount:"金额",
      currency:"币种",
      gwNo:"网关号",
      amountCnt:"总金额",
      cnt:"总笔数",
      succRate:"成功率",


      wan: "{value}万",
      tooltipDate: "日期：{date}",

      tooltipSuccAmount: "成功金额：{amount}",


      tenThousand:'万'

    },
    // 交易表报
    showMerFormsTradeListInfo:{
      trdate:"交易时间",
      TotalsuccCnt:"成功总笔数",
      TotalsuccAmount:"成功总金额",
      protestCnt:"拒付总笔数",
      protestAmount:"拒付总金额",
      ProtestRate:"拒付率",
      TotalunnAmount:"退款总金额",
      unnRate:"退款率",
    },
    // 月度对账单
    showMerTranSactionSettlemenListInfo:{
      choice:"选择",
      hkbatchNo:"划款批次号",
      tsAmount:"划款金额",
      gatewayNo:"网关接入号",
      tsCreatetime:"制表时间",
      tsStatus:"处理状态",
      tsSetttime:"划款时间",
      tsSettbank:"划款银行",
      tsFactAmount:"实划金额",
      tsProtestFee:"拒付处理费",
      refundFee:"退款处理费",
      settFee:"结算费用",
      monthfee:"月服务费",
      amountCurrency:"扣款币种",
      tsProtestAmount:"拒付罚金",
      tsNkAmount:"内扣金额",
      tsOtherAmount:"其它扣款",
      specialAmount:"特殊扣款",
      returnAmount:"返还款项",
      tsMsuccCount:"月成功交易笔数",
      tsMproCount:"当月产生的拒付笔数",
      tsMproRate:"拒付率",
      tsRemrak:"划款备注"
    },
    // 成功率表报
    mainPage:{
      gwNo:"网关号",
      country:"卡所属国家",
      billname:"账单地址",
      currency:"币种",
      amount:"总金额",
      cnt:"总笔数",
      allUniqueEmails:"总笔数邮箱去重",
      succUniqueEmails:"成功笔数邮箱去重",
      allUniqueCard:"总笔数卡号去重",
      succUniqueCard:"成功笔数卡号去重",
      succAmount:"成功金额",
      succCnt:"成功笔数",
      succRate1:"成功率",
      emailSuccessRate:"邮箱去重成功率",
      cardSuccessRate:"卡号去重成功率",
      succAmountRate:"成功金额率",
      failAmount:"失败金额",
      failCnt:"失败笔数",
      unnAmount:"退款金额",
      unnCnt:"退款笔数",
      unnRate:"退款率",
    },
    // 按钮
    button:{
      download:"下载",
      update:"修改",
      add:"新增",
      delete:"删除",
      check:"审核",
      detail:"订单详细",
      logistics:"物流",
      updateKey:"修改网关 Key",
      updateNoKey:"网关 key不能为空",
      keyCheckIserror:"Key值必须8-15位数字或字母",
      gwCheckUpdatedecalre:"修改key,需要与接口的key一致,否则导致支付失败,你确定要修改",
      batchUpload:"批量上传",
      resetPasswords:"重置密码",
      stop:"停用",
      enable:"启用",
    },
    // 商户信息
    merchant:{
      merchantInfo:"商户信息",
      merNo:"商户号",
      merName:"商户名称",
      merArea:"所属区域",
      busId:"所属行业",
      merCerType:"证件类型",
      merCerNo:"证件号",
      merState:"省/州",
      merCity:"城市名",
      merAddress:"联系地址",
      merLinkman:"联系人",
      merLinkphone:"联系电话",
      merFax:"QQ",
      gwStatus:"状态",
      merWebsite:"公司网址",
      merEmail:"邮箱地址",
      merTradedays:"交易结算周期",
      merReservedays:"保证金结算周期",
      merUploadtype:"上传单据类型",
      merRegdate:"注册日期",
      merPactstdate:"合同起始日期",
      merPactendate:"合同结束日期",

      overseas:"海外",
      domestic:"国内",
      idCard:"身份证",
      tradingCertificate:"营业执照",
      mer_status_del:"删除",
       // 商户详细展示状态
        status:{
          code_0: '未激活',
          code_1: '正常',
          code_2: '测试',
          'code_-1': '停用',
          'code_-2': '删除',
          code_null: '未知状态',
          code_undefined: '未知状态'
      },
      dayFormat:'{num} 天',
      merUploadtype0:"只能上传图片",
      merUploadtype1:"只能填写跟踪单号",
      merUploadtype2:"既能上传图片又能填写跟踪单号",
      gwNo:"网关接入号",
      gwMd5key:"key",

      gwInfType:"接口类型",
      gwCreatetime:"操作时间",
      mer_status_stop:"停用",
      mer_status_nonactivated:"未激活",
      mer_status_normal:"正常",
      mer_status_test:"测试",
      no_infrace:"无网关设置",
      twofive_infrace:"2.5方",
      two_infrace:"2方",
      three_infrace:"3方",
    },
    // 账户信息
    MerBankAccount:{
      mbaBankname:"开户银行",
      mbaBankholder:"开户用户名",
      mbaBankaccount:"开户账号",
      mbaBandadd:"开户银行地址",
      mbaBankCountry:"开户行地址国别",
      mbaCurrency:"银行账户币种",
      mbaIsdefault:"是否为默认账号",
      mbaStatus:"状态",
      mbaCheckUser:"审核人",
      mbaCheckTime:"审核时间",
      mbaCheckReason:"审核/复核原因",
      loginName:"操作人",
      oprtime:"操作时间",
      remark:"备注",
      yes:"是",
      no:"否",
      mbaStatus_0:"待审核",
      mbaStatus_1:"已审核待复核",
      mbaStatus_2:"已复核",
      'mbaStatus_-1':"审核失败",
      'mbaStatus_-2':"复核失败",

    },
    // 登录日志
    forwardLoginLogList:{
      success:"成功",
      fail:"失败",
      adminid:"帐号(登入名)",
      status:"登陆状态",
      syslogname:"姓名",
      syslogip:"登录IP",
      logintime:"登录时间",
      failreason:"失败原因",
      aoOperatetype:"操作类型",
      add:"新增",
      del:"删除",
      modify:"修改",
      maName:"操作人姓名",
      aoModelname:"操作模块",
      operatingContent:"操作内容",
      operatingTime:"操作时间",


    },
    // 账户信息
    showMerbankaccount:{
      merbankaccount_add:"新增账户信息",
      merbankaccount_update:"修改账户信息",
      merbankaccount_check:"审核账户信息",
      checkStatus:"审核状态",
      checkStatus_1:"审核通过",
      checkStatus_2:"审核失败",
      mbaStatus_iv_oe:"审核状态必须选择，请确认",
      merState :"省/州",
      merCity:"城市名",
      mbaCurrency:"银行账户币种",
      mbaPayeeProperty:"收款人属性",
      mbaPayeeAddress:"收款人地址",
      mbaPayeeCountry:"收款人地址国别",
      mbaMiddleBank:"中间行",
      mbaMiddleBankcode:"中间行代码",
      mbaSwiftCode:"SWIFT CODE",
      mbaIban:"IBAN",
      mbaPayBank:"打款银行",
      remark:"备注",
      alert_modify_normal:"只能修改状态为已复核的信息",
      alert_check_normal:"只能审核状态为待审核的信息",
      mba_checkuserissame:"审核人与操作人不能相同",
      mba_update_exists:"该账户信息已经在修改",
      alert_delete_normal:"默认账户不能删除",
      alert_del_role:"你确定删除吗?",
      mbaBankname_iv_oe:"开户银行必须输入2到100个字符，请确认",
      mbaBankholder_iv_oe:"开户用户名必须输入2到100个字符，请确认",
      mbaBankaccount_iv_oe:"开户账号必须输入2到100个字符，请确认",
      merState_fv_of:"省/州可以为空，最多可输入50个字符",
      merCity_fv_of:"城市名可以为空，最多可输入50个字符",
      mbaBandadd_fv_of:"开户银行地址必须输入，可输入2到100个字符",
      mbaBankCountry_fv_of:"开户行地址国别必须填写，最多可输入100个字符",
      mbaBankcurrency_fv_of:"结算币种必须选择",
      mbaPayeeProperty_fv_of:"收款人属性必须填写，最多可输入100个字符",
      mbaPayeeAddress_fv_of:"收款人地址必须填写，最多可输入100个字符",
      mbaPayeeCountry_fv_of:"收款人地址国别必须填写，最多可输入100个字符",
      mbaMiddleBank_fv_of:"中间行可以为空，最多可输入100个字符",
      mbaMiddleBankcode_fv_of:"中间行代码可以为空，最多可输入100个字符",
      mbaSwiftCode_fv_of:"SWIFT CODE 必须填写，最多可输入100个字符",
      mbaIban_fv_of:"IBAN可以为空，最多可输入100个字符",
      mbaPayBank_fv_of:"打款银行属性可以为空，最多可输入100个字符",
      remark_fv_of:"备注可为空，输入长度0-500个字符",
      mbaBankaccount_ajax:"银行账号已存在，请重新输入",
    },
    // 新闻中心
    showNewsManage:{
      news_title:"新闻公告标题",
      send_time:"发布时间",
      unread:"未读",
      read:"已阅",
      cancel:"取消",
      news_details:"新闻公告详情",
    },
    // 退款
    forwardRefundmentList:{
      tradeNo:"流水订单号",
      merOrderNO:"商户订单号",
      mercheckStatus:"管理员复核状态",
      refundamount:"退款金额",
      refundreason:"退款原因",
      processstatus:"处理状态",
      fail:"失败",
      waitdispose:"待审核",
      checkSuccessButNotProcess:"审核成功未处理",
      success:"成功",
      operater:"申请人",
      refundtime:"申请时间",
      processtime:"处理时间",
      tradingTime:"交易时间",
      returnurl:"返回地址",
      website:"交易网址",
      email:"邮箱",
      mercheckStatus0:"未复核",
      mercheckStatus1:"已复核",
      TimeType:"时间类型",
      applyTime:"申请时间",
      proTime:"处理时间",
      rdrTagPrompt:"是否预警退款",
      yes:"是",
      no:"否",
      alert_check_confirm:"确定要对所选记录进行复核吗",
      tradeNo_fv_of:"请输入流水订单号",
      refundamount_fv_of:"退款金额<=交易金额-(已退款金额+已冻结金额+已拒付金额)",
      refundamount_iv_oe:"退款金额必须输入1-16位的正整数或正小数，请确认",
      refundReason_iv_oe:"退款原因必须输入1-100个字符，请确认",
      tradeAmount:"交易金额",
      gwNo:"网关接入号",
      canbackamount:"可退金额",
      refundtype:"退款形式",
      allrefund:"全部退款",
      litrefund:"部分退款",
      submitRefund:"提交退款申请",
      refundAmount:"退款金额必须大于0",
      refundAmountCom:"退款金额不能超过可退款金额 {amount} {currency}",
    },
    // 系统设置
    findManagers:{
      remark:"备注",
      query:"查询",
      syslogname :"登录用户名",
      random:"随机生成",
      loginName:"登录名",
      adminNameAll:"管理员姓名",
      status:"状态",
      adminRole:"管理员角色",
      creator:"操作人",
      createdate:"操作时间",

      normal:"正常",
      stopUsing:"停用",
      delete:"删除",
      password:"密码",

      oldPassword:"原密码",
      newPassword:"新密码",
      confirmPassword:"确认密码",
      pleaseEnterTheOriginalPassword:"请输入原密码",
      pleaseEnterANewPassword:"请输入新密码",
      pleaseReEnterTheNewPasswordToConfirm:"请输入确认密码",
      passwordLimit:"密码必须是在8~16位之间的字母、数字或下划线",
      passwordDifferent:"两次输入的密码不一致",

      roleNameInChinese:"角色中文名称",
      roleName: "角色英文名称",
      select: "选择",
      whetherToDisplayAccountDynamic:"是否显示账户动态",
      roleDescription:"角色描述",
      add:"新增",
      modify:"修改",
      websitePermissions:"网站权限",
      rolePermissions:"角色权限",
      rolePermissionsOptions:"角色权限选择",
      pleaseSelect:"请选择",
      yes:"是",
      no:"否",
      pleaseEnterTheChineseRoleName:"请输入角色中文名称",
      pleaseEnterTheEnglishRoleName:"请输入角色名称",
      pleaseEnterARoleDescription:"请输入角色描述",
      areYouSureToDeleteIt:"你确定删除吗",
      cancel:"取消",
      CnNameRule:"角色中文名称不能为空，且必须由数字、字母或者下划线组成,请确认",
      EnNameRule:"角色英文名称不能为空，且必须由数字、字母或者下划线组成,请确认",
      pleaseSelectSRecord:"您没有选择记录,请选择",
      pleaseSelecTheRolePermissions:"请选择角色权限",
      id:"ID",

      loginNamefv : "请输入登录名",
      adminHint:"确认停用该管理员吗？",
      adminopen:"确认启用该管理员吗？",
      banSucc:"停用成功",
      banErr:"停用失败",
      alertStart:"只允许选择状态为停用的管理员进行恢复,请重新选择",
      alertStop:"只允许选择状态为正常的管理员进行停用,请重新选择",
      EnabledSucc:"启用成功",
      EnabledErr:"启用失败",

      resetpwd : "密码重置成功",
      alertDel:"你确定删除吗",
      delSucc:"删除成功",


      pleaseEnterLoginName: '请输入登录名',
      loginNameLength: '登录名长度在2到15个字符之间',
      pleaseEnterPassword: '请输入密码',
      passwordMinLength: '密码不能少于8个字符',
      pleaseEnterName: '请输入姓名',
      nameLength: '姓名长度在2到15个字符之间',
      pleaseSelectRole: '请选择角色',
    },
    // 风险挡掉交易
    initUnTradeRecordPage:{
      Interface:"接口问题",
      Risk:"风控问题",
      Cardholder:"持卡人未完成支付",
      other:"其他原因",
      timetype2:"时区",
      businessOrderno:"商户订单号",
        randomOrderno:"流水订单号",
      gatewayNo:"网关接入号",
      remark:"备注",
      tradeStartDate:"交易开始日期",
      tradeEndDate:"交易结束日期",
      expReason:"挡掉原因",
      tradingURL:"交易网址",
      tradeMoney:"交易金额",
      returnurl:"返回地址",
      tradeTime:"交易时间",
      wrongcode:"错误代码",
      wronginfo:"错误信息",
      businessmanNo:"商户号",
      submiturl:"提交地址",
      cardCountry:"卡BIN所在国家",
      ipCountry:"支付国",
      untradedetailinfo:"风险挡掉交易详情",

    },
    // 当前交易明细
    initTradeRecordPage:{
      tradeState1:"待确认",
      tradeState2:"待处理",
      tradeState3:"失败",
      tradeState4:"成功",
      appropriationState1:"未划款",
      appropriationState2:"已制表",
      appropriationState3:"已划款",
      yes:"是",
      no:"否",
      tsType1:"首次",
      orderdetial:"订单详细",
      refchapro:"退款变拒付",
      noexplain:"未申诉",
      explaing:"申诉中",
      failed:"失败",
      success:"成功",
      paymentState:"支付状态",
      noConfirm:"待确认",
      noProcess:"待处理",
      fail:"失败",
      TimeType:"时间类型",
      tradeTime:"交易时间",
      comfirmDate:"确认时间",
      freezeState:"冻结状态",
      freezeState1:"未冻结",
      freezeState2:"已冻结",
      drawbackState:"退款状态",
      noDrawback:"未退款",
      okDrawback:"已退款",
      refusalPaymentState:"拒付状态",
      noRefusalPayment:"未拒付",
      okRefusalPayment:"已拒付",
      appropriationState:"交易划款状态",
      notAppropriation:"未划款",
      okAppropriation:"已划款",
      okMakeTable:"已制表",
      trRsStatus:"保证金划款状态",
      email:"邮箱",
      tradingURL:"交易网址",
      cardNum:"卡号",
      firstSix:"前六位",
      afterFour:"后四位",
      trIsexplain:"申诉状态",
      ipAddress:"IP地址",
      Pre_authorization:"是否预授权",
      toutouState:"妥投状态",
      tuotouState0:"未妥投",
      tuotouState1:"已妥投",
      uploaded:"是否上传单据",
      expStatus7:"申诉失败",
      expStatus8:"申诉成功",
      expStatus9:"申诉中",
      upExpType1:"拒付申诉",
      upExpType2:"冻结申诉",
      congealtime:"冻结时间",
      protesttime:"拒付时间",
      cpdtime: "CPD 日期",
      appDate:"申诉时间",
      startDate:"开始日期",
      endDate:"结束日期",
      randomOrderno:"流水订单号",
      businessOrderno:"商户订单号",
      isExp:"是否申诉",
      upExpType:"申诉类型",
      gatewayNo:"网关接入号",
      tradeMoney:"交易金额",
      protectMoney:"保证金",
      isOrNotFreeze:"是否冻结",
      congealamout:"冻结金额",
      isOrNotRefusalPayment:"是否拒付",
      protestamout:"拒付金额",
      expStatus:"申诉状态",
      expAmount:"申诉金额",
      expFailReson:"申诉失败原因",
      backinfo:"返回信息",
      upReason:"异常原因",
      cny_amout:"人民币金额",
      isOrNotDrawback:"是否退款",
      refualamout:"退款金额",
      ciIssuingbank:"发卡行",
      Payment:"支付方式",
      whetherRedirect:"是否跳转",
      transactionDetials:"交易信息",
      trackingno:"跟踪单号",
      tbLogisticsWebsite:"物流网站",
      trAmout:"订单金额",
      payinfo:"支付信息",
      tradeurl:"交易网址",
      custIp:"客户IP",
      merIp:"商户IP",
      returnurl:"返回地址",
      trTsId:"划款批次号",
      tsType:"划款类型",
      payCurrncy:"支付币种",
      tradeDeductRate:"交易扣率",
      onePoundageCurrncy:"单笔手续费币种",
      onePoundage:"单笔手续费",
      guaranteeMoneyDeductRate:"保证金扣率",
      appropriationCurrncy:"划款币种",
      appropriationExchangeRate:"划款汇率",
      orderinfo:"账单信息",
      custName:"客户姓名",
      custemail:"客户邮箱",
      custipcode:"客户邮编",
      custtel:"客户电话",
      trenttime:"进入系统时间",
      ciAddress:"地址",
      entpaytime:"进入支付页面时间",
      ciCity:"城市",
      submittime:"提交支付时间",
      ciState:"州",
      ciCountry:"账单国",
      trbacktime:"返回时间",
      billaddress:"账单地址",
      shipInfo:"收件人信息",
      shipname:"收件人姓名",
      shipphone:"收件人电话",
      shipcountry:"收件人国家",
      shipstate:"收件人州",
      shipcity:"收件人城市",
      shipaddress:"收件人地址",
      shipzip:"收件人邮编",
      riskInformation:"风险信息",
      flagkuatrade:"跨国支付",
      binCountry:"真实发卡国",
      ipCountry:"支付国",
      highriskcountry:"高风险国家",
      ipcountryinfo:"IP信息",
      successTradeAmt:"成功交易笔数",
      b_t_s_amt:"保证金总额",
      t_amt:"支付总金额",
      t_s_amt:"成功金额",
      cny_amt:"人民币总金额",
      strokeCount:"笔",
      batchUploadTitle: "批量上传发货凭证",
      modifyTitle: "修改发货凭证",
      downloadTip: "请先下载模板，填写后再上传。",
      downloadTemplate: "下载模板",
      selectExcel: "选择Excel",
      startUpload: "开始上传",
      orderNo: "订单号",
      trackingNo: "跟踪单号",
      logisticsWebsite: "物流网站",
      remark: "备注说明",
      noData: '暂无数据'

    },
    // 测试交易
    initTestTradePage:{
      businessOrderno:"商户订单号",
      randomOrderno:"流水订单号",
      startDate:"开始日期",
      endDate:"结束日期",
      gatewayNo:"网关接入号",
      tradeMoney:"交易金额",
      guaranteeMoneyDeductRate:"保证金扣率",
      paymentState:"支付状态",
      website:"交易网址",
      returnurl:"返回地址",
      tradeTime:"交易时间",
      wrongcode:"错误代码",
      wronginfo:"错误信息",

    },
    // 结算明细
    settlement:{
      SettlementDetails:"结算明细",
      PaymentDetails:"划款明细",
      TransactionSettlement:"划款交易明细",
      tradeTitle:"划款交易明细下载",
      settdetailtitle:"划款明细下载",
      startDate:"制表开始时间",
      endDate:"制表结束时间",
      tsId:"划款批次号",
      tsAmount:"划款金额",
      tsCreatetime:"制表时间",
      tsStatus:"处理状态",
      tsStatus_3:"已取消",
      tsStatus_2:"复核失败",
      tsStatus_1:"审核失败",
      tsStatus0:"待处理",
      tsStatus1:"已审核待复核",
      tsStatus2:"已复核待处理",
      tsStatus3:"已处理",
      tsSetttime:"划款时间",
      tsSettbank:"划款银行",
      tsFactAmount:"实划金额",
      tsProtestFee:"拒付处理费",
      tsRefundFee:"退款处理费",
      tsSettFee:"结算费用",
      tsMonthFee:"月服务费",
      tsAmountCurrency:"扣款币种",
      tsProtestAmount:"拒付罚金",
      tsNkAmount:"内扣金额",
      tsOtherAmount:"其它扣款",
      tsSpecialAmount:"特殊扣款",
      tsReturnAmount:"返还款项",
      succCountStr:"月成功交易笔数",
      proCountStr:"当月产生的拒付笔数",
      proRateStr:"拒付率",
      tsRemrak:"划款备注",
      tsdSettType:"划款类型",
      tsdSettType1:"首次",
      tsdSettType2:"补款",
      tsdGwNo:"网关接入号",
      tsdCurrency:"支付币种",
      tsdSettCurrency:"划款币种",
      tsdTradeCount:"成功笔数",
      tsdTradeFailCount:"失败笔数",
      tsdRefundmentCount:"退款笔数",
      tsdProtestCount:"拒付笔数",
      tsdCongealCount:"冻结笔数",
      tsdExplainCount:"申诉成功笔数",
      tsdTradeAmount:"成功金额",
      tsdRefundmentAmount:"退款金额",
      tsdProtestAmount:"拒付金额",
      tsdCongealAmount:"冻结金额",
      tsdExplainAmount:"申诉成功金额",
      tsdTraderate:"交易扣率",
      tsdSppAmount:"单笔手续费金额",
      tsdBailrate:"保证金扣率",
      tsdReserverAmount:"保证金",
      tsdFeeAmount:"手续费",
      tsdSppAmounts:"单笔手续费",
      tsdTradeTotal:"应划金额(按支付币种)",
      tsdSettTotal:"应划金额(按划款币种)",
      trNo:"流水订单号",
      trSettRate:"划款汇率",
      trAmount:"成功金额",
      trStatus:"交易状态",
      trStatus_2:"待确认",
      trStatus_1:"待处理",
      trStatus0:"失败",
      trStatus1:"成功",
      trTradeRate:"交易扣率",
      trSppCurrency:"单笔手续费币种",
      trSpp:"单笔手续费金额",
      trReseverRate:"保证金扣率",
      trDatetime:"交易时间",
      trRefundment:"退款状态",
      trRefundment0:"未退款",
      trRefundment1:"已退款",
      trProtest:"拒付状态",
      trProtest0:"未拒付",
      trProtest1:"已拒付",
      trCongeal:"冻结状态",
      trCongeal0:"未冻结",
      trCongeal1:"冻结",
      trIsexplain:"申诉状态",
      trIsexplain_2:"未申诉",
      trIsexplain_1:"申诉中",
      trIsexplain0:"失败",
      trIsexplain1:"成功",
      trRefundmentAmount:"退款金额",
      trProtestAmount:"拒付金额",
      trCongealAmount:"冻结金额",
      trFEEFailMER:"失败订单是否收取单笔手续费",
      trFEESuccessMER:"划款前交易金额全部异常是否收取单笔手续费",
      trFEESuccessAfterMER:"划款后交易金额全部异常是否收取单笔手续费",
      trIsBackMER:"划款前异常金额是否收取手续费",
      trIsBackAfterMER:"划款后异常金额是否收取手续费",
      collect:"收取",
      uncollect:"不收",
    },
    // 保证金明细
    deposit: {
      SettlementDetails: "保证金明细",
      PaymentDetails: "划款明细",
      TransactionSettlement: "划款交易明细",
      tradeTitle: "划款交易明细下载",
      settdetailtitle: "划款明细下载",
      startDate: "制表开始时间",
      endDate: "制表结束时间",
      rsId: "划款批次号",
      rsAmount:"划款金额",
      rsCreatetime:"制表时间",
      rsStatus:"处理状态",
      rsStatus_3:"已取消",
      rsStatus_2:"复核失败",
      rsStatus_1:"审核失败",
      rsStatus0:"待处理",
      rsStatus1:"已审核待复核",
      rsStatus2:"已复核待处理",
      rsStatus3:"已处理",
      rsSettime:"划款时间",
      rsSetbank:"划款银行",
      rsFactAmount:"实划金额",
      rsAmountCurrency:"扣款币种",
      rsNkAmount:"内扣金额",
      rsOtherAmount:"其它扣款",
      rsRemrak:"划款备注",
      rsdGwNo:"网关接入号",
      rsdTrCurrency:"支付币种",
      rsdSettCurrency:"划款币种",
      rsdBailrate:"保证金扣率",
      rsdTradeCount:"成功笔数",
      rsdTradeAmount:"成功金额",
      rsdRefundmentAmount:"退款金额",
      rsdProtestAmount:"拒付金额",
      rsdTradeTotal:"应划金额(按支付币种)",
      rsdSettTotal:"应划金额(按划款币种)",
      trNo:"流水订单号",
      trSettRate:"划款汇率",
      trAmount:"成功金额",
      trStatus:"交易状态",
      trStatus_2:"待确认",
      trStatus_1:"待处理",
      trStatus0:"失败",
      trStatus1:"成功",
      trReseverRate:"保证金扣率",
      trDatetime:"交易时间",
      trRefundment:"退款状态",
      trRefundment0:"未退款",
      trRefundment1:"已退款",
      trProtest:"拒付状态",
      trProtest0:"未拒付",
      trProtest1:"已拒付",
      trCongeal:"冻结状态",
      trCongeal0:"未冻结",
      trCongeal1:"冻结",
      trRefundmentAmount:"退款金额",
      trProtestAmount:"拒付金额",
      trCongealAmount:"冻结金额",
    },
    // 获取vt链接
    toGetPayLinks:{
      quickInfo:"您没有开通快捷支付的网关接入号",
      amount:"交易金额",
      currency:"请选择币种",
      gwNo:"网关接入号",
      getpayurl:"获取支付链接",
      payurl:"支付链接",
      copyData:"复制链接",
      copySuccess:"复制成功",
      noAmount:"交易金额不能为空",
      verifyAmount:"交易金额必须为1-16位的正整数或正小数，请确认",
      verifyGwNo:"网关接入号必须选择，请确认",
      copyFail:"复制失败，请手动复制",
    },
    ...elementZhLocale
  },
  'en-US': {
    login: 'Login',
    logout: 'log out',
    dashboard: 'Dashboard',
    orderQuery: 'Order Query',
    query: 'Query',
    submit:"Submit",
    reset: 'Reset',
    startDate:"Start Date",
    endDate:"End Date",
    currency:"Currency",
    choose:"Choose",
    cancel:"cancel",
    sure:"Sure",
    succeed:"Succeed",
    export_success:"Export Success",
    export_fail:"Export Fail",
    selectAll:"Select All",
    Excel:"Please select Excel.",
    statusUnknown:"Unknown type :",
    alert_select:"Please select a record",
    please_input:"please input",
    selected:"Selected",
    record:"Record",
    requestFailed:"Request failed, please try again later",
    unknownStatus:"Unknown state",
    multipleValues:"Please enter multiple values separated by commas. Up to 1000 values are supported. Example: VALUE1,VALUE2,VALUE3",
    setValuesSuccess:"{count} value(s) set",
    addError:"New addition failed",
    updaSucceed:"modify successfully",
    updaError:"fail to modify",
    please_inputOrder:"please input Order No",
    DownloadInfo:"The download file is being generated. Please wait...",
    export_truncated_warning: 'Data too large, only first {exported} records exported (total {original})',
    date:"Time Horizon",
    selectDateRange:"Please select a date range",
    day : "days",
    //登录页面
    loginPage: {
      title: 'Sign In',
      desc: 'Welcome to Merchant Backend System',
      merNo:"Enter your merno id",
      accountPlaceholder: 'Enter your account',
      passwordPlaceholder: 'Enter your password',
      captchaPlaceholder: 'Enter your captcha',
      submitBtn: 'Login',
      accountRequired: 'Account is required',
      passwordRequired: 'Password is required',
      serverError: 'Server connection failed, please try again later...'
    },
    // 主页
    home: {
      successAmount: 'Weekly success amount',
      allCnt: 'Weekly total orders',
      allSuccCnt: 'Weekly success orders',
      allSuccRate:"Weekly success rate",
      WeeklyData:"Weekly trading data",
      Date:"Date",
      succAmount:"Success amount (¥)",
      succCnt:"Success count",
      failAmount:"Fail amount (¥)",
      failCnt:"Fail count",
      proportion:"Success/failure ratio",
      succOrder:"Success order",
      failOrder:"Fail order",
      seriesName:"Order Status",
      count:"pen",
      allUniqueEmails:"Total Unique Emails",
      succUniqueEmails:"Successful Unique Emails",
      emailSuccessRate:"Unique Email Rate",
      allUniqueCard:"Total Unique Cards",
      succUniqueCard:"Successful Unique Cards",
      cardSuccessRate:"Unique Cards Rate",
      successAmountTrend:"Trend of successful transaction amounts",
      amount:"Amount",
      currency:"Reporting Currency",
      gwNo:"Gateway No",
      amountCnt:"Total Amount",
      cnt:"Total Transactions",
      succRate:"Success Rate",

      wan: "{value}0K",
      tooltipDate: "Date: {date}",
      tooltipSuccAmount: "Success Amount: {amount}",

      tenThousand:'W'
    },
    // 交易表报
    showMerFormsTradeListInfo:{
      trdate:"Transaction date",
      TotalsuccCnt:"Total  Successful Transactions",
      TotalsuccAmount:"Total Successful Amount",
      protestCnt:"Total Protested Payments",
      protestAmount:"Total Protest Amount",
      ProtestRate:"Protest Rate",
      TotalunnAmount:"Total Refunded Amount",
      unnRate:"Refund Rate",
    },
    // 月度对账单
    showMerTranSactionSettlemenListInfo:{
      choice:"Selected",
      hkbatchNo : "Transfer Batch No.",
      tsAmount : "Settlement Amount",
      gatewayNo : "Gateway No.",
      tsCreatetime : "Time Created",
      tsStatus:"Process Status",
      tsSetttime : "Settlement Time",
      tsSettbank : "Settlement Bank",
      tsFactAmount : "The Net Settlement Amount",
      tsProtestFee : "Chargeback Fee",
      refundFee :"Refund processing fee",
      settFee :"Settlement costs",
      monthfee :"Monthly service fee",
      amountCurrency:"Deduction of currency",
      tsProtestAmount : "Chargeback Amount",
      tsNkAmount : "Deduction Amount",
      tsOtherAmount : "Other Deduction Fees",
      specialAmount :"Special deductions",
      returnAmount :"Return of funds",
      tsMsuccCount:"Monthly Approved Count",
      tsMproCount:"Chargeback Count",
      tsMproRate:"Chargeback Ratio (%)",
      tsRemrak : "Settlement Remarks"
    },
    // 成功率表报
    mainPage:{
      gwNo:"Gateway No",
      country:"Card Issuing Country",
      billname:"Billing Address",
      currency:"Reporting Currency",
      amount:"Total Amount",
      cnt:"Total Transactions",
      allUniqueEmails:"Total Unique Emails",
      succUniqueEmails:"Successful Unique Emails",
      allUniqueCard:"Total Unique Cards",
      succUniqueCard:"Successful Unique Cards",
      succAmount:"Successful Amount",
      succCnt:"Successful Transactions",
      succRate1:"Success Rate",
      emailSuccessRate:"Unique Email Rate",
      cardSuccessRate:"Unique Cards Rate",
      succAmountRate:"Success Amount Ratio",
      failAmount:"Failed Amount",
      failCnt:"Failed Transactions",
      unnAmount:"Refunded Amount",
      unnCnt:"Refunded Transactions",
      unnRate:"Refund Rate",
    },
    // 按钮
    button:{
      download:"Download",
      update:"Update",
      add:"Add",
      updateKey:"Update Key",
      delete:"Delete",
      check:"Check",
      detail:"Order Details",
      logistics:"Logistics",
      updateNoKey:"key cannot be left blank.",
      keyCheckIserror:"Error. Transaction code must not be less than 8 digits.",
      gwCheckUpdatedecalre:"Modified transaction code must be the same as the interface transaction code. Otherwise, payment will fail. Are you sure to modify?",
      batchUpload:"Batch Upload",
      resetPasswords:"reset passwords",
      stop:"Stop",
      enable:"Enable",
    },
    // 商户信息
    merchant:{
      merchantInfo:"Merchant Information",
      merNo:"MID",
      merName:"Merchant Name",
      merArea:"Region",
      busId:"Industry",
      merCerType:"Document Type",
      merCerNo:"D Number",
      merState:"Province / State",
      merCity:"City",
      merAddress:"Address",
      merLinkman:"Contact Person",
      merLinkphone:"Contact Number",
      merFax:"QQ",
      merWebsite:"Company Website",
      merEmail:"Email address",
      merTradedays:"Settlement Cycle",
      merReservedays:"Reserve Settlement Cycle",
      merUploadtype:"Delivery Types",
      merRegdate:"Registration Date",
      merPactstdate:"Contract Start Date",
      merPactendate:"Contract End Date",


      overseas:"Overseas",
      domestic:"Domestic",
      idCard:"Kimlik",
      tradingCertificate:"isletme Lisansi",
      mer_status_del:"Delete",
      // 商户详细展示状态
      status:{
        code_0: 'Not Activated',
        code_1: 'Normal',
        code_2: 'Test',
        'code_-1': 'Disabled',
        'code_-2': 'Delete',
        code_null: 'unknown state',
        code_undefined: 'unknown state'
      },
      dayFormat: '{num} Days',
      merUploadtype0 : "Only upload images",
      merUploadtype1 : "only upload tracking number",
      merUploadtype2 : "Either the image or tracking number",
      gwNo:"Gateway No",
      gwMd5key:"key",
      gwStatus:"Status",
      gwInfType:"Interface Type",
      gwCreatetime:"Processing Date",
      mer_status_stop:"Disabled",
      mer_status_nonactivated:"Not Activated",
      mer_status_normal:"Normal",
      mer_status_test:"Test",
      no_infrace:"No Gateway Set",
      twofive_infrace:"2.5-Party",
      two_infrace:"2-Party",
      three_infrace:"3-party",
    },
    // 账户信息
    MerBankAccount:{
      mbaBankname:"Beneficiary Bank",
      mbaBankholder:"Beneficiary Account Name",
      mbaBankaccount:"Beneficiary Account No.",
      mbaBandadd:"Beneficiary Bank Address",
      mbaBankCountry:"Country of Beneficiary Bank",
      mbaCurrency:"Account Currency",
      mbaIsdefault:"Default Account(Y/N)",
      mbaStatus:"Status",
      mbaCheckUser:"Auditor",
      mbaCheckTime:"Audit time",
      mbaCheckReason:"Audit/review reasons",
      loginName:"Processor",
      oprtime:"Processing Date",
      remark:"Remark",
      yes:"yes",
      no:"no",
      mbaStatus_0:"Pending audit",
      mbaStatus_1:"Audited to be reviewed",
      mbaStatus_2:"Has Been reviewed",
      'mbaStatus_-1':"Audit failure",
      'mbaStatus_-2':"Review failure",
    },
    forwardLoginLogList:{
      success:"Success",
      fail:"Failure",
      adminid : "Login Name (User Name)",
      status:"Login state",
      syslogname:"Name",
      syslogip:"Login IP",
      logintime:"Login Time",
      failreason:"Reasons for failure",
      aoOperatetype:"Operation type",
      add:"Add",
      del:"Del",
      modify:"Modify",
      maName:"Processor",
      aoModelname:"Operation Module",
      operatingContent:"Operating Content",
      operatingTime:"Operating Time",


    },
  showMerbankaccount:{
      merbankaccount_add:"Add Account information",
      merbankaccount_update:"Modify Account information",
      merbankaccount_check:"Audit account information",
      checkStatus:"Audit Status",
      checkStatus_1:"Audit through",
      checkStatus_2:"Audited failure",
      mbaStatus_iv_oe:"Audit status must be chosen, please check",
      merState : "Province / State",
      merCity : "City",
      mbaCurrency:"Account Currency",
      mbaPayeeProperty:"Personal/Company Account",
      mbaPayeeAddress:"Beneficiary Address",
      mbaPayeeCountry:"Country of Beneficiary",
      mbaMiddleBank:"Intermediary Bank",
      mbaMiddleBankcode:"Intermediary Bank SWIFT CODE",
      mbaSwiftCode:"SWIFT CODE",
      mbaIban:"IBAN",
      mbaPayBank:"Remitting Bank",
      remark:"Remark",
      alert_modify_normal:"You can only modify the status of the record has been reviewed",
      alert_check_normal:"You can only Audit the status of pending record",
      mba_checkuserissame:"The auditor and the operator can not be the same",
      mba_update_exists:"The account information has been modified",
      alert_delete_normal:"The default account can not be deleted",
      alert_del_role:"Are you sure you want to delete it?",
      mbaBankname_iv_oe:"Beneficiary Bank entered must be 2-100 characters",
      mbaBankholder_iv_oe:"Account username must be 2 and 100 characters",
      mbaBankaccount_iv_oe:"Beneficiary Account No. must be 2 and 100 characters",
      merState_fv_of:"Province / state can be empty",
      merCity_fv_of:"City can be empty",
      mbaBandadd_fv_of:"Beneficiary Bank Address must be 2-100 characters",
      mbaBankCountry_fv_of:"Country of Beneficiary Bank must be entered, Can enter up to 100 characters",
      mbaBankcurrency_fv_of:"Settlement currency must be chosen",
      mbaPayeeProperty_fv_of:"Personal/Company Account must be entered, Can enter up to 100 characters",
      mbaPayeeAddress_fv_of:"Beneficiary Address must be entered, Can enter up to 100 characters",
      mbaPayeeCountry_fv_of:"Country of Beneficiary must be entered, Can enter up to 100 characters",
      mbaMiddleBank_fv_of:"Intermediary Bankcan be empty, Can enter up to 100 characters",
      mbaMiddleBankcode_fv_of:"Intermediary Bank SWIFT CODE can be empty, Can enter up to 100 characters",
      mbaSwiftCode_fv_of:"SWIFT CODE must be entered, Can enter up to 100 characters",
      mbaIban_fv_of:"IBAN can be empty, Can enter up to 100 characters",
      mbaPayBank_fv_of:"Remitting bank can be empty, Can enter up to 100 characters",
      remark_fv_of:"Remarks can be empty, input can only be a maximum of 500 characters",
      mbaBankaccount_ajax : "Bank account already exists, please re-enter",
  },
    // 新闻中心
    showNewsManage:{
      news_title:"Duyuru Basligi",
      send_time:"yayinlanma zamani",
      unread:"Unread",
      read:"Okunmus",
      cancel:"cancel",
      news_details:"Haber Detaylari",
    },
    // 退款
    forwardRefundmentList:{
      tradeNo:"Transaction Order No.",
      merOrderNO:"Merchant Order No.",
      mercheckStatus:"Review the status",
      refundamount:"Refund Amount",
      refundreason:"Refund Reason",
      processstatus:"Processing Status",
      fail:"Failed",
      waitdispose:"waitdispose",
      checkSuccessButNotProcess:"Under Audit",
      success:"Successful",
      operater:"Applicant",
      refundtime:"Application Time",
      processtime:"Processing Time",
      tradingTime:"Trading Hours",
      returnurl:"Merchants Return URL",
      website:"Merchant Submitted Source URL",
      email:"Email",
      mercheckStatus0:"Under aduit",
      mercheckStatus1:"Approved",
      TimeType:"Time Type",
      applyTime:"Application time",
      proTime:"Processing time",
      rdrTagPrompt:"Is there a refund warning",
      yes:"Yes",
      no:"No",
      alert_check_confirm:"Please confirm you want to for checking the selected record",
      tradeNo_fv_of:"Transaction order number can not be less than 22 digits",
      refundamount_fv_of:"Refund amount <= transaction amount - (amount of refund + frozen amount + non-payment amount)",
      refundamount_iv_oe:"Refund amount is incorrect, please re-enter",
      refundReason_iv_oe:"Refund reason must be entered, and should not exceed 100 characters",
      tradeAmount:"Transaction Amount",
      gwNo:"Gateway No.",
      canbackamount:"Actual amount to be refunded",
      refundtype:"Refund in the form",
      allrefund:"All refund",
      litrefund:"Partial refund",
      submitRefund:"Submit a refund application",
      refundAmount:"The refund amount must be greater than 0.",
      refundAmountCom:"Refund amount cannot exceed the refundable amount {amount} {currency}",
    },
    // 系统设置
    findManagers:{
      remark:"Remark",
      query:"Query",
      syslogname :"Login User Name",
      random:"random generation",
      loginName:"Login",
      adminNameAll:"Administrator Name",
      status:"Status",
      adminRole:"Administrator Role",
      creator:"Creator",
      createdate:"Date Created",

      normal:"Normal",
      stopUsing:"Disabled",
      delete:"Delete",

      password:"Password",
      oldPassword:"Original Password",
      newPassword:"New Password",
      confirmPassword:"Confirm Password",
      pleaseEnterTheOriginalPassword:"Please enter the original password",
      pleaseEnterANewPassword:"please enter a new password",
      pleaseReEnterTheNewPasswordToConfirm:"Please Re-enter the new Password to confirm",
      passwordLimit:"Password must be between 8 ~ 16 letters, numbers",
      passwordDifferent:"2 passwords entered are not the same. Please try again",

      roleNameInChinese:"Role Name in Chinese",
      roleName: "Role Name",
      select: "Select",
      whetherToDisplayAccountDynamic:"Whether to display account dynamic",
      roleDescription:"Role Description",
      add:"add",
      modify:"Modify",
      websitePermissions:"Website Permissions",
      rolePermissions:"Role Permissions",
      rolePermissionsOptions:"Role permissions Options",
      pleaseSelect:"Please Select",
      yes:"yes",
      no:"no",
      pleaseEnterTheChineseRoleName:"Please enter the Chinese Role Name",
      pleaseEnterTheEnglishRoleName:"Please enter the English Role Name",
      pleaseEnterARoleDescription:"Please enter a role description",
      areYouSureToDeleteIt:"Are you sure to delete it",
      cancel:"Cancel",
      CnNameRule:"Chinese Role Name can not be empty, and the length can not exceed 15 characters, please confirm",
      EnNameRule:"Role Name can not be empty, and the length can not exceed 15 characters, please confirm",
      pleaseSelectSRecord:"Please select a record",
      pleaseSelecTheRolePermissions:"Please select the role permissions",
      id:"ID",
      loginNamefv: "Please enter the login name",
      adminHint:"Are you sure to deactivate this administrator?",
      adminopen:"Are you sure to enable this administrator?",
      banSucc:"Deactivation successful",
      banErr:"Deactivation failed",
      alertStart:"Only allows you to select disabled administrator to be restored, please re-select",
      alertStop:"Only allows to select the normal status administrator to disable, please re-select.",
      EnabledSucc:"Enabled successfully",
      EnabledErr:"Enabled to enable",

      resetpwd : "Password reset Succ",
      alertDel:"silmek istediginizden eminmisiniz?",
      delSucc:"successfully delete",

      pleaseEnterLoginName: 'Please enter login name',
      loginNameLength: 'Login name must be 2-15 characters',
      pleaseEnterPassword: 'Please enter password',
      passwordMinLength: 'Password must be at least 8 characters',
      pleaseEnterName: 'Please enter name',
      nameLength: 'Name must be 2-15 characters',
      pleaseSelectRole: 'Please select a role',
    },
    // 风险挡掉交易
    initUnTradeRecordPage:{
      Interface:"Interface issues",
      Risk:"Risk control",
      Cardholder:"The cardholder is not complete payment",
      other:"Other reasons",
      timetype2:"Time Zone",
      businessOrderno:"Merchant Order No.",
        randomOrderno:"Order No.",
      gatewayNo:"Gateway No.",
      remark:"Remarks",
      tradeStartDate:"Start Date",
      tradeEndDate:"End Date",
      expReason:"Block reason",
      tradingURL:"Processing URL",
      tradeMoney:"Transaction Amount",
      returnurl:"Return URL",
      tradeTime:"Transaction Time",
      wrongcode:"Error Code",
      wronginfo:"Error Message",
      businessmanNo:"Merchant ID",
      submiturl:"Submitted Address",
      cardCountry:"Card Bin Country",
      ipCountry:"The transaction IP of the country",
      untradedetailinfo:"Abnormal Transaction Details",
    },
    // 当前交易明细
    initTradeRecordPage:{
      tradeState1:"To be Confirmed",
      tradeState2:"Pending",
      tradeState3:"Failed",
      tradeState4:"Successful",
      appropriationState1:"Unsettled",
      appropriationState2:"Reported",
      appropriationState3:"Settled",
      yes:"Yes",
      no:"No",
      tsType1:"First Time",
      orderdetial:"Order Detials",
      refchapro:"Refuned turn into Chargeback",
      noexplain:"Non appeal",
      explaing:"Under Appeal",
      failed:"Failed",
      success:"Successful",
      paymentState:"Result",
      noConfirm:"To be Confirmed",
      noProcess:"Pending",
      fail:"Failed",
      TimeType:"Time Type",
      tradeTime:"Transaction Time",
      comfirmDate:"Confirm Date",
      freezeState:"Frozen Status",
      freezeState1:"No",
      freezeState2:"Yes",
      drawbackState:"Refund Status",
      noDrawback:"Unrefunded",
      okDrawback:"Refunded",
      refusalPaymentState:"Chargeback Status",
      noRefusalPayment:"Non Chargeback",
      okRefusalPayment:"Chargeback",
      appropriationState:"Settlement Status",
      notAppropriation:"Unsettled",
      okAppropriation:"Settled",
      okMakeTable:"Reported",
      trRsStatus:"Reserve Status",
      email:"Cardholders Email",
      tradingURL:"Processing URL",
      cardNum:"Card No.",
      firstSix:"First 6 digits",
      afterFour:"Last 4 digits",
      trIsexplain:"Appeal Status",
      ipAddress:"IP Address",
      Pre_authorization:"Pre-authorization",
      toutouState:"Delivery Status",
      tuotouState0:"Not Delivered",
      tuotouState1:"Delivered",
      uploaded:"Tracking No.",
      expStatus7:"Appeal Failed",
      expStatus8:"Appeal Successful",
      expStatus9:"Appealing",
      upExpType1:"Chargeback Appeal",
      upExpType2:"Freeze Appeal",
      congealtime:"Frozen Time",
      protesttime:"Chargeback Time",
      cpdtime: "CPD Date",
      appDate:"Appeal Time",
      startDate:"Start Date",
      endDate:"End Date",
      randomOrderno:"Order No.",
      businessOrderno:"Merchant Order No.",
      isExp:"Whether the appeal",
      upExpType:"Appeal Type",
      gatewayNo:"ateway No.",
      tradeMoney:"Transaction Amount",
      protectMoney:"Rolling Reserve",
      isOrNotFreeze:"Frozen",
      congealamout:"Frozen Amount",
      isOrNotRefusalPayment:"Chargeback",
      protestamout:"Chargeback Amount",
      expStatus:"Appeals status",
      expAmount:"Appeal Amount",
      expFailReson:"Appeal failed resson",
      backinfo:"Bank Response",
      upReason:"Abnormal",
      cny_amout:"CNY Amount",
      isOrNotDrawback : "Refund",
      refualamout:"Refund Amount",
      ciIssuingbank:"Issuing bank",
      Payment:"Payment",
      whetherRedirect:"whether Redirect",
      transactionDetials:"Transaction Detials",
      trackingno : "Tracking No.",
      tbLogisticsWebsite:"Shipping URL",
      trAmout:"Transaction Amount",
      payinfo:"Payment Info",
      tradeurl:"Transaction URL",
      custIp:"Cardholder IP",
      merIp:"Merchant IP",
      returnurl:"Return URL",
      trTsId:"Transfer Batch No.",
      tsType:"Transaction Settlement Type",
      payCurrncy:"Payment Currency",
      tradeDeductRate:"Transaction deduction rate",
      onePoundageCurrncy:"Per Transaction Fee Currency",
      onePoundage :"Per Transaction Fee",
      guaranteeMoneyDeductRate:"Rolling Reserve Rate",
      appropriationCurrncy:"Settlement Currency",
      appropriationExchangeRate:"Settlement Exchange Rate",
      orderinfo : "Billing Information",
      custName:"Cardholder Name",
      custemail:"Email Address",
      custipcode:"Postcode",
      custtel:"Phone Number",
      trenttime:"Access System Time",
      ciAddress:"Address",
      entpaytime:"Access Payment Page Time",
      ciCity:"City",
      submittime:"Submit Payment Time",
      ciState:"State",
      ciCountry:"Billing Country",
      trbacktime:"Response Time",
      billaddress:"Billing Descriptor",
      shipInfo:"Shipping Info",
      shipname:"Shipping Name",
      shipphone:"Shipping Phone",
      shipcountry:"Shipping countries",
      shipstate:"Shipping states",
      shipcity:"Shipping city",
      shipaddress:"Shipping address",
      shipzip:"Shipping Zip Code",
      riskInformation:"Risk Information",
      flagkuatrade:"Cross Border Payments",
      binCountry:"The card issuers States",
      ipCountry:"The transaction IP of the country",
      highriskcountry:"High Risk Countries",
      ipcountryinfo:"IP Information",
      successTradeAmt:"Approved Transaction",
      b_t_s_amt:"Reserve Amount",
      t_amt:"Transaction Amount",
      t_s_amt:"Approved Amount",
      cny_amt:"CNY Transaction",
      strokeCount:"Stroke Count",
      batchUploadTitle: "Batch Upload Shipping Voucher",
      modifyTitle: "Modify Shipping Voucher",
      downloadTip: "Please download the template first, fill it in and then upload.",
      downloadTemplate: "Download Template",
      selectExcel: "Select Excel",
      startUpload: "Start Upload",
      orderNo: "Order No.",
      trackingNo: "Tracking No.",
      logisticsWebsite: "Logistics Website",
      remark: "Remarks",
      noData: 'No data found.'
    },
    // 测试交易
    initTestTradePage:{
      businessOrderno:"isletme siparis Numarasi",
      randomOrderno:"siparis numarasi",
      startDate:"Baslangic tarihi",
      endDate:"Bitis tarihi",
      gatewayNo:"Gateway No.",
      tradeMoney:"islem Tutari",
      guaranteeMoneyDeductRate:"Yuvarlama erzerv orani",
      paymentState:"odeme durumu",
      website:"URL kaynagi",
      returnurl:"isletme adresine don",
      tradeTime:"islem suresi",
      wrongcode:"Hata kodu",
      wronginfo:"Hata mesaji",

    },
    // 结算明细
    settlement:{
      SettlementDetails:"Settlement Details",
      PaymentDetails:"Debited Details",
      TransactionSettlement:"Transaction Settlement",
      tradeTitle:"Transfer Txn Details Excel",
      settdetailtitle:"Transfer Deatil Excel",
      startDate:"Report Start Time",
      endDate:"Report End Time",
      tsId:"Transfer Batch Number",
      tsAmount:"Settlement Amount",
      tsCreatetime:"Time Created",
      tsStatus:"Process Status",
      tsStatus_3:"Canceled",
      tsStatus_2:"Review Failed",
      tsStatus_1:"Audit Failed",
      tsStatus0:"Pending",
      tsStatus1:"Under Review",
      tsStatus2:"Processing",
      tsStatus3:"Processed",
      tsSetttime:"Settlement Time",
      tsSettbank:"Settlement Bank",
      tsFactAmount:"The Net Settlement Amount",
      tsProtestFee:"Chargeback Fee",
      tsRefundFee:"Refund processing fee",
      tsSettFee:"Settlement costs",
      tsMonthFee:"Monthly service fee",
      tsAmountCurrency:"Deduction of currency",
      tsProtestAmount:"Chargeback Amount",
      tsNkAmount:"Deduction Amount",
      tsOtherAmount:"Other Deduction Fees",
      tsSpecialAmount:"Special deductions",
      tsReturnAmount:"Return of funds",
      succCountStr:"Monthly Approved Count",
      proCountStr:"Chargeback Count",
      proRateStr:"Chargeback Ratio (%)",
      tsRemrak:"Settlement Remarks",
      tsdSettType:"Txn Settlement Type",
      tsdSettType1:"First Time",
      tsdSettType2:"Patch",
      tsdGwNo:"Gateway No",
      tsdCurrency:"Payment Currency",
      tsdSettCurrency:"Settlement Currency",
      tsdTradeCount:"Approved Transaction Count",
      tsdTradeFailCount:"Failed Transaction Count",
      tsdRefundmentCount:"Refunded Transaction Count",
      tsdProtestCount:"Chargedback Transaction Count",
      tsdCongealCount:"Number Of Frozen Transactions",
      tsdExplainCount:"Approved Complaints Count",
      tsdTradeAmount:"Approved Transaction Amount",
      tsdRefundmentAmount:"Refunded Transaction Amount",
      tsdProtestAmount:"Amount Of Chargedback Transactions",
      tsdCongealAmount:"Amount Of Frozen Transactions",
      tsdExplainAmount:"Approved Complaints Amount",
      tsdTraderate:"MDR",
      tsdSppAmount:"Per Transaction Fee",
      tsdBailrate:"Rolling Reserve Rate",
      tsdReserverAmount:"Rolling Reserve",
      tsdFeeAmount:"Fee",
      tsdSppAmounts:"Per Transaction Fee",
      tsdTradeTotal:"Transaction Settlement Amount (According to currency paid)",
      tsdSettTotal:"Transaction settlement amount (According to transfer currency)",
      trNo:"Transaction Order No",
      trSettRate:"Settlement Exchange Rate",
      trAmount:"Approved Transaction Amount",
      trStatus:"Transaction Status",
      trStatus_2:"Pendig",
      trStatus_1:"Processing",
      trStatus0:"Failed",
      trStatus1:"Success",
      trTradeRate:"MDR",
      trSppCurrency:"Per Transaction Fee Currency",
      trSpp:"Per Transaction Fee",
      trReseverRate:"Rolling Reserve Rate",
      trDatetime:"Transaction Time",
      trRefundment:"Refund Status",
      trRefundment0:"Unrefunded",
      trRefundment1:"Refunded",
      trProtest:"Chargeback Status",
      trProtest0:"Non chargeback",
      trProtest1:"Chargeback",
      trCongeal:"Frozen Status",
      trCongeal0:"Non frozen",
      trCongeal1:"Frozen",
      trIsexplain:"Complaint Status",
      trIsexplain_2:"Not Appeal",
      trIsexplain_1:"Appealing",
      trIsexplain0:"Failure",
      trIsexplain1:"Succeeded",
      trRefundmentAmount:"Refunded Transaction Amount",
      trProtestAmount:"Amount Of Chargedback Transactions",
      trCongealAmount:"Amount Of Frozen Transactions",
      trFEEFailMER:"Whether to charge per transaction fee for failed order or not",
      trFEESuccessMER:"whether to charge per transaction fee for abnormal transaction amount before transfer",
      trFEESuccessAfterMER:"Whether to charge per transaction fee for abnormal transaction amount after transfer",
      trIsBackMER:"Whether to charge MDR for abnormal transaction amount before transfer",
      trIsBackAfterMER:"Whether to charge MDR for abnormal transaction amount after transfer",
      collect:"Charge",
      uncollect:"Do not charge",
    },
    deposit: {
      SettlementDetails:"Settlement Details",
      PaymentDetails:"Debited Details",
      TransactionSettlement:"Transaction Settlement",
      tradeTitle:"Transfer Txn Details Excel",
      settdetailtitle:"Transfer Deatil Excel",
      startDate:"Report Start Time",
      endDate:"Report End Time",
      rsId:"Transfer Batch Number",
      rsAmount:"Settlement Amount",
      rsCreatetime:"Time Created",
      rsStatus:"Process Status",
      rsStatus_3:"Canceled",
      rsStatus_2:"Review Failed",
      rsStatus_1:"Audit Failed",
      rsStatus0:"Pending",
      rsStatus1:"Under Review",
      rsStatus2:"Processing",
      rsStatus3:"Processed",
      rsSettime:"Settlement Time",
      rsSetbank:"Settlement Bank",
      rsFactAmount:"The Net Settlement Amount",
      rsAmountCurrency:"Deduction of currency",
      rsNkAmount:"Deduction Amount",
      rsOtherAmount:"Other Deduction Fees",
      rsRemrak:"Settlement Remarks",
      rsdGwNo:"Gateway No",
      rsdTrCurrency:"Payment Currency",
      rsdSettCurrency:"Settlement Currency",
      rsdBailrate:"Rolling Reserve Rate",
      rsdTradeCount:"Approved Transaction Count",
      rsdTradeAmount:"Approved Transaction Amount",
      rsdRefundmentAmount:"Refunded Transaction Amount",
      rsdProtestAmount:"Amount Of Chargedback Transactions",
      rsdTradeTotal:"Transaction Settlement Amount (According to currency paid)",
      rsdSettTotal:"Transaction settlement amount (According to transfer currency)",
      trNo:"Transaction Order No",
      trSettRate:"Settlement Exchange Rate",
      trAmount:"Approved Transaction Amount",
      trStatus:"Transaction Status",
      trStatus_2:"Pendig",
      trStatus_1:"Processing",
      trStatus0:"Failed",
      trStatus1:"Success",
      trReseverRate:"MDR",
      trDatetime:"Transaction Time",
      trRefundment:"Refund Status",
      trRefundment0:"Unrefunded",
      trRefundment1:"Refunded",
      trProtest:"Chargeback Status",
      trProtest0:"Non chargeback",
      trProtest1:"Chargeback",
      trCongeal:"Frozen Status",
      trCongeal0:"Non frozen",
      trCongeal1:"Frozen",
      trRefundmentAmount:"Refunded Transaction Amount",
      trProtestAmount:"Amount Of Chargedback Transactions",
      trCongealAmount:"Amount Of Frozen Transactions",
    },
    // 获取vt链接
    toGetPayLinks:{
      quickInfo:"Please apply for a Virtual Terminal gateway",
      amount:"Transaction amount",
      currency:"Please select currency",
      gwNo:"Gateway No.",
      getpayurl:"Quick Payment Links",
      payurl:"Payment link",
      copyData:"Copy Link",
      copySuccess:"copy Success",
      noAmount:"The transaction amount cannot be left blank.",
      verifyAmount:"The transaction amount must be a positive integer or positive decimal number ranging from 1 to 16 digits. Please confirm.",
      verifyGwNo:"Gateway number must be chosen, please confirm",
      copyFail:"Copy failed. Please do it manually.",
    },
    ...elementEnLocale
  }
}

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'en-US',
  messages: messages
})

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})


// 将 echarts 挂载到 Vue 上
Vue.prototype.$echarts = echarts





// 引入 axios
import axios from 'axios'
// 将 axios 挂载到 Vue 上
Vue.prototype.$axios = axios
axios.defaults.withCredentials = true;
// 设置接口请求的前缀地址
/* axios.defaults.baseURL = 'http://127.0.0.1:9558/api'*/
// 全局设置token 和 语言 请求拦截
axios.interceptors.request.use(function (config) {
  let token = sessionStorage.getItem('token')
  if (token) {
    config.headers['token'] = token
    config.headers.Authorization = token
  }
  // 优先从 i18n 实例中获取当前语言，如果没有则读取 localStorage，再没有就默认 'zh'
  let lang = i18n.locale || localStorage.getItem('lang') || 'zh-CN'

  // HTTP 头部 Accept-Language
  config.headers['Accept-Language'] = lang

  return config
}, function (error) {
  return Promise.reject(error);
})


axios.interceptors.response.use(
    response => {
      return response
    },
    error => {
      if (error.response) {

        const { status, data } = error.response

        if (status === 401) {

          if (data && data.code === 401001 || data.code === 401003) {
            handleTokenExpired()
            return Promise.resolve();
          }

        }

      }

      return Promise.reject(error)
    }
)



let isLogout = false

function handleTokenExpired() {

  console.log("进入handleTokenExpired")

/*  if (isLogout) {
    console.log("已经退出过")
    return
  }*/

  isLogout = true

  sessionStorage.clear()
  localStorage.removeItem("token")

  console.log("准备跳转")

  router.replace("/login")
  //this.$router.push("/login");
  return;
}


import App from './App'


Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js